import React from 'react';
import './App.css';
import Home from './components/pages/Home';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Setting } from './components/pages/Setting';
import { RecoilRoot } from 'recoil';
import { Useage } from './components/pages/Useage';
import { Result } from './components/pages/Result';
import { PrivacyPolicy } from './components/pages/PrivacyPolicy';
import { TermsOfService } from './components/pages/TermsOfService';


function App() {
  return (
    <BrowserRouter>
      <RecoilRoot>
        <Routes>
          <Route path="/home" element={<Home/>} />
          <Route path="/setting" element={<Setting/>} />
          <Route path="/party/:partyId" element={<Result />} /> 
          <Route path="/" element={<Home/>} />
          <Route path="*" element={<Home/>} />
          <Route path="/useage" element={<Useage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </RecoilRoot>
    </BrowserRouter>
  );
}

export default App;